import React, { Component } from "react";
import Header from "../../components/Header/Header";
import "./styles.css";
import senhaIcon from "../../assets/img/senha-icon.png";

export default class Login extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Header history={this.props.history}>
        <div className="login">
          <form className="login__form">
            <div className="login__form__content">
              <div className="row">
                <div className="col-12  col-md-6   ">
                  <label htmlFor="name" className="login__form__content__label">
                    {" "}
                    NOME{" "}
                  </label>
                  <input
                    id="name"
                    type="text"
                    className="login__form__content__input"
                  />
                </div>
                <div className="col-12  col-md-6   ">
                  <label
                    htmlFor="lastName"
                    className="login__form__content__label"
                  >
                    {" "}
                    SOBRENOME{" "}
                  </label>
                  <input
                    id="lastName"
                    type="text"
                    className="login__form__content__input"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <label
                    htmlFor="email"
                    className="login__form__content__label"
                  >
                    {" "}
                    EMAIL{" "}
                  </label>
                  <input
                    id="email"
                    type="email"
                    className="login__form__content__input"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-5">
                  <label
                    htmlFor="password"
                    className="login__form__content__label"
                  >
                    {" "}
                    SENHA{" "}
                  </label>
                  <input
                    id="password"
                    type="password"
                    className="login__form__content__input"
                  />
                </div>
                <div className="col-12 col-md-5">
                  <label
                    htmlFor="confirmPassword"
                    className="login__form__content__label"
                  >
                    {" "}
                    CONFIRMA SENHA{" "}
                  </label>
                  <input
                    id="confirmPassword"
                    type="password"
                    className="login__form__content__input"
                  />
                </div>
                <div className="col-12 col-md-1">
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <button
                      style={{
                        backgroundColor: "transparent",
                        marginTop: "20px"
                      }}
                    >
                      <img
                        style={{ width: "25px", height: "15px" }}
                        src={senhaIcon}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div className="login__form__content__termscontent">
                <label className="container-label" htmlFor="termos">
                  Concordo com os
                  <span className="login__form__content__termscontent__highlights">
                    Nossas políticas de uso
                  </span>
                  <input
                    required
                    name="amount-boook-radio"
                    id="termos"
                    type="radio"
                    value="100"
                  />
                  <span
                    style={{ marginTop: "2px", backgroundColor: "transparent" }}
                    className="checkmark"
                  />
                </label>
              </div>
            </div>
            <div className="login__form__contentbutton">
              <button className="login__form__contentbutton__button">
                Cadastrar
              </button>
            </div>
          </form>
        </div>
      </Header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/RegisterUser/index.js